const customFieldColumns = [
  {
    key: 'lotNumber',
    label: '#',
    sort: 'lotNumber',
    configExclude: true
  },
  {
    key: 'actions',
    label: '',
    sort: '',
    configExclude: true
  },
  {
    key: 'title',
    label: 'Lot Name',
    sort: 'title',
    configExclude: true
  },
  {
    key: 'category',
    label: 'Cat',
    sort: 'specs.category',
    configExclude: false,
    configShowDefault: true
  },
  // {
  //   key: 'colour',
  //   label: 'Colour',
  //   sort: 'specs.colour',
  //    configExclude: true
  // },
  {
    key: 'age',
    label: 'Age',
    sort: 'specs.age',
    configExclude: false,
    configShowDefault: true
  },
  {
    key: 'sex',
    label: 'Sex',
    sort: 'specs.sex',
    configExclude: false,
    configShowDefault: true
  },
  {
    key: 'sire',
    label: 'Sire',
    sort: 'specs.sire',
    configExclude: false,
    configShowDefault: true
  },
  {
    key: 'dam',
    label: 'Dam',
    sort: 'specs.dam',
    configExclude: false,
    configShowDefault: true
  },
  {
    key: 'damSire',
    label: 'Dam Sire',
    sort: 'specs.damSire',
    configExclude: false,
    configShowDefault: false
  },
  {
    key: 'inFoal',
    label: 'In Foal',
    sort: 'specs.inFoal',
    configExclude: false,
    configShowDefault: false
  },
  {
    key: 'coveringStallion',
    label: 'Covering Stallion',
    sort: 'specs.coveringStallion',
    configExclude: false,
    configShowDefault: false
  },
  {
    key: 'vendor',
    label: 'Vendor',
    sort: 'specs.vendor',
    configExclude: false,
    configShowDefault: true
  },
  {
    key: 'horseLocation',
    label: 'Location',
    sort: 'specs.horseLocation',
    configExclude: false,
    configShowDefault: true
  },
  {
    key: 'buyer',
    label: 'Buyer',
    sort: 'specs.buyer',
    configExclude: false,
    configShowDefault: false
  },
  {
    key: 'stretchy',
    label: '',
    sort: '',
    configExclude: true
  },
  {
    key: 'endingTime',
    label: 'End Time',
    sort: '',
    configExclude: true
  },
  {
    key: 'status',
    label: 'Status',
    sort: '',
    configExclude: true
  },
  {
    key: 'bids',
    label: 'Price',
    sort: 'currentBid',
    configExclude: true
  }
]

export default customFieldColumns
